import React, { useLayoutEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { clearCabinCrews, getCabinCrews } from '../../../actions';
import { optionsPropTypes } from '../forms/select/SelectPropTypes';
import SelectFilter from './SelectFilter';

const CabinCrewFilter = ({
  dispatchGetCabinCrews,
  dispatchClearCabinCrews,
  options,
  onChangeFilter,
}) => {
  useLayoutEffect(() => {
    dispatchGetCabinCrews();
    return () => dispatchClearCabinCrews();
  }, []);

  return (
    <SelectFilter isMulti onChangeFilter={onChangeFilter} options={options} />
  );
};

CabinCrewFilter.propTypes = {
  dispatchGetCabinCrews: PropTypes.func.isRequired,
  dispatchClearCabinCrews: PropTypes.func.isRequired,
  options: optionsPropTypes,
  onChangeFilter: PropTypes.func.isRequired,
};

CabinCrewFilter.defaultProps = {
  options: [],
};

const mapStateToProps = ({ TrafficUnit }) => ({
  options: TrafficUnit.CabinCrew.getIn(['all', 'content', 'content']).map(
    (cabinCrew) => ({
      value: cabinCrew.id,
      label: `${cabinCrew.customer.idDocumentNumber} - ${cabinCrew.customer.firstName} ${cabinCrew.customer.lastName}`,
    }),
  ),
});

const mapDispatchToprops = {
  dispatchGetCabinCrews: getCabinCrews,
  dispatchClearCabinCrews: clearCabinCrews,
};

export default connect(mapStateToProps, mapDispatchToprops)(CabinCrewFilter);
